import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ec567b48&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ec567b48&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec567b48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec567b48')) {
      api.createRecord('ec567b48', component.options)
    } else {
      api.reload('ec567b48', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ec567b48&scoped=true", function () {
      api.rerender('ec567b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/userList/index.vue"
export default component.exports